<dentr-navbar
  class="transition-all duration-200 ease-out"
  [ngClass]="{ 'pb-9': devService.isImpersonationVisible, 'pb-4': !devService.isImpersonationVisible }"
  [practiceName]="commonService.practice.name"
></dentr-navbar>
<dentr-header></dentr-header>
<dentr-content></dentr-content>
<dentr-portal-santa [attr.aria-hidden]="showSanta" *ngIf="showSanta" @fadeInAnimation></dentr-portal-santa>
